const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInNOutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.5 163.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "In-N-Out Burger logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M408.77,452.91a6.2,6.2,0,0,0,2-4.19c0-2.83-2.27-5.89-7-5.91l-8.34-.07V465h10.16a8.1,8.1,0,0,0,5.32-1.87,5.6,5.6,0,0,0,1.66-4.13,6.14,6.14,0,0,0-3.79-6.09m-7-4.84a3.54,3.54,0,0,1,2.32.55,1.41,1.41,0,0,1,.47,1.11,1.3,1.3,0,0,1-.42,1,3.74,3.74,0,0,1-2.4.61Zm3.66,11.3c-1,.83-3,.58-3.68.48v-3.56c.63-.08,2.62-.26,3.61.54A1.52,1.52,0,0,1,406,458a1.57,1.57,0,0,1-.52,1.35",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,442.75h-6.12V456.8A3.35,3.35,0,0,1,426,460a3.32,3.32,0,0,1-2.45-.88,3.52,3.52,0,0,1-.91-2.25V442.75h-6.32v14.8a8,8,0,0,0,2.13,5.41c1.64,1.71,4.08,2.57,7.26,2.59h.07c3.29,0,5.83-.88,7.54-2.63a8.16,8.16,0,0,0,2.25-5.45V442.75Z",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.2,449.94a6.62,6.62,0,0,0-1.86-4.86,7.82,7.82,0,0,0-5.28-2.23l-9.4-.11V465H447v-7l4.66,7h7.91L453,456.29c1-.51,4.17-2.47,4.22-6.34M450,451.62a4.33,4.33,0,0,1-2.9.83l0-4.58a4.44,4.44,0,0,1,2.85.79,1.87,1.87,0,0,1,.59,1.45,2,2,0,0,1-.56,1.51",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.92,452.29l0,5.27,4.46,0a3.75,3.75,0,0,1-3.81,2.82A5.08,5.08,0,0,1,468.8,459a7,7,0,0,1-1.67-5c0-3.19,2.47-6.13,5.16-6.17h.07c2.47,0,3.9,2.13,4.35,3.39l.09.24,6.18-2.73-.1-.22a11.24,11.24,0,0,0-9.92-6.28,12.09,12.09,0,0,0-9,3.32,12,12,0,0,0-3.34,8.76,10.71,10.71,0,0,0,3.07,7.92,12.56,12.56,0,0,0,8.81,3.29h.22c3.42,0,11.36-1.41,11.28-13v-.24Z",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.22 162.56 258.26 162.56 258.26 157.06 251.65 157.06 251.66 154.3 257.96 154.32 257.98 148.83 251.72 148.82 251.73 146.03 258.26 146 258.26 140.29 245.22 140.29 245.22 162.56",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.61,456.23c1-.48,4.36-2.37,4.42-6.25a6.84,6.84,0,0,0-1.9-5,7.31,7.31,0,0,0-5-2.13l-9.88-.08V465h6.4v-7.22l4.69,7.22h7.9Zm-3-4.59a4.42,4.42,0,0,1-3.11.79l0-4.58a5,5,0,0,1,3.18.82,1.64,1.64,0,0,1,.53,1.27,2.27,2.27,0,0,1-.62,1.7",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.4 140.3 116.49 162.65 141.29 162.65 128.47 140.3 99.4 140.3",
    style: {
      fill: "#ffcb05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,356.89l-14.63-19.5s-1.17-2.13-2.93-1.59c-1,.3-1.14,1.58-1.14,3.39,0,1.6-.38,7.94-.47,9.41L269.45,303.4c-8.5-1.6-15.68-1.95-19.77,5.41s3.34,14.92,5.09,17.39l41.6,55.59H337l-18.18-32.56-.06-.09c-.28-.4-1.21-2-.67-3s2.2-.86,4-.59l172.55,20.23L492,374.89s-.91,2.29.44,2.94,2.26-.22,3.39-.89,19.73-14.63,19.73-14.63,1.81-1.12,1.82-2.48a7.08,7.08,0,0,0-1.35-2.95",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#ffcb05"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.86,460.35a4.81,4.81,0,1,1-4.78-4.8,4.79,4.79,0,0,1,4.78,4.8m-8.9,0a4.09,4.09,0,1,0,4.11-4.07,4.08,4.08,0,0,0-4.11,4.07m6.48,2.71h-.8l-1.51-2.48h-1.19V463h-.69l0-5.4h2.37a2.06,2.06,0,0,1,1.3.3,1.32,1.32,0,0,1,.61,1.16c0,1.07-.77,1.46-1.7,1.47Zm-2.5-3c.75,0,1.91.12,1.92-1,0-.81-.72-.91-1.38-.91H341V460Z",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 87.91,
    width: 12.14,
    height: 43.81,
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.58 112.9 31.83 88.05 31.72 87.91 19.56 87.91 19.56 131.72 31.91 131.72 31.91 106.04 51.66 131.58 51.77 131.72 63.9 131.72 63.9 87.91 51.58 87.91 51.58 112.9",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.35 113.15 98.04 87.91 85.94 87.91 85.94 131.72 98.23 131.72 98.23 106.04 118.43 131.58 118.54 131.72 130.58 131.72 130.58 87.91 118.35 87.91 118.35 113.15",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.63,
    y: 103.87,
    width: 13.46,
    height: 11.88,
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.19,
    y: 103.87,
    width: 13.46,
    height: 11.88,
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.48,389.3h-.1A24.93,24.93,0,0,0,402.17,396a22.59,22.59,0,0,0-7.23,16.44c0,12.84,10.88,23.32,24.37,23.37h.09c13.44,0,24.4-10.38,24.44-23.19S433,389.35,419.48,389.3m8.36,31.35A12.22,12.22,0,0,1,419.4,424h0a12.23,12.23,0,0,1-8.46-3.37,11,11,0,0,1,.06-16.08,12.22,12.22,0,0,1,8.44-3.31h.05a12.22,12.22,0,0,1,8.46,3.37,11,11,0,0,1-.06,16.08",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.23 87.91 251.23 98.21 260.67 98.21 260.67 131.7 272.94 131.7 272.94 98.21 282.38 98.21 282.38 87.91 251.23 87.91",
    style: {
      fill: "#e02a27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.44,390.37v25.94s.08,3.87-2.23,6.29a6.8,6.8,0,0,1-5,2,6.21,6.21,0,0,1-4.71-1.69c-2.42-2.39-2.41-6.55-2.41-6.59V390.37H449l0,27.52a18.16,18.16,0,0,0,4.71,12.26c3.39,3.53,8.36,5.34,14.76,5.36h.13c7.66,0,13.2-2.49,16.48-7.4a17.47,17.47,0,0,0,2.84-9.08l-.06-28.65H475.44Z",
    transform: "translate(-242.75 -302.45)",
    style: {
      fill: "#e02a27"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInNOutLogo);
export default __webpack_public_path__ + "static/media/in-n-out-logo.d8f02813cf525f40c1089181eb27c655.svg";
export { ForwardRef as ReactComponent };